(function() {
  'use strict';
  
  function findVariantByOptions(materialType) {
    // Get product data from ShopifyAnalytics
    let product = null;
    
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      product = window.ShopifyAnalytics.meta.product;
    }
    
    if (!product || !product.variants) {
      console.error('Product data not found');
      return null;
    }
    
    console.log('Looking for material type:', materialType);
    
    // The exact option values based on your product
    const materialOption = materialType === 'peel' ? 'Peel & Stick' : 'Traditional';
    
    // Find all variants that match the material type using public_title
    // public_title format: "Peel & Stick / Small Sample" or "Traditional / Large Sample"
    const matchingVariants = product.variants.filter(function(variant) {
      // Check if public_title starts with the material type
      return variant.public_title && variant.public_title.startsWith(materialOption);
    });
    
    console.log('Matching variants for ' + materialOption + ':', matchingVariants);
    
    if (matchingVariants.length === 0) {
      console.error('No variants found for material type:', materialOption);
      return null;
    }
    
    // From the matching variants, find the one with "Small Sample"
    let selectedVariant = null;
    
    // First try to find "Small Sample" specifically
    selectedVariant = matchingVariants.find(function(variant) {
      return variant.public_title && variant.public_title.toLowerCase().includes('small sample');
    });
    
    // If no "Small Sample" found, get the first variant with this material type
    if (!selectedVariant) {
      selectedVariant = matchingVariants[0];
    }
    
    if (selectedVariant) {
      console.log('Selected variant:', selectedVariant);
      return selectedVariant.id;
    }
    
    return null;
  }
  
  function addToCart(variantId) {
    if (!variantId) {
      console.error('No variant ID provided');
      alert('Unable to find the sample variant');
      return;
    }
    
    console.log('Adding variant to cart:', variantId);
    
    // Add to cart using FormData
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'sections--25931001626948__cart-drawer');
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      console.log('Added to cart successfully:', data);
      
      // Get the cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      
      // If sections data is returned, update the drawer content
      if (data.sections && data.sections['sections--25931001626948__cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections['sections--25931001626948__cart-drawer'], 'text/html');
        const newContent = doc.querySelector('cart-drawer');
        
        if (cartDrawer && newContent) {
          cartDrawer.innerHTML = newContent.innerHTML;
        }
      } else {
        // Fallback: fetch the cart section manually
        fetch('/?sections=sections--25931001626948__cart-drawer')
          .then(function(response) { return response.json(); })
          .then(function(sections) {
            if (sections['sections--25931001626948__cart-drawer']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(sections['sections--25931001626948__cart-drawer'], 'text/html');
              const newContent = doc.querySelector('cart-drawer');
              
              if (cartDrawer && newContent) {
                cartDrawer.innerHTML = newContent.innerHTML;
              }
            }
            
            // Open the drawer after updating
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          });
        return;
      }
      
      // Update cart count in header
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          const cartCountElements = document.querySelectorAll('.cart-link__count');
          cartCountElements.forEach(function(el) {
            el.textContent = cart.item_count;
          });
        });
      
      // Open the drawer
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, there was an error adding the sample to your cart.');
    });
  }
  
  function initSampleButtons() {
    // Peel & Stick button
    const peelStickButtons = document.querySelectorAll('a[href="#add-sample-peel-stick"]');
    peelStickButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Peel & Stick sample button clicked');
        const variantId = findVariantByOptions('peel');
        addToCart(variantId);
      });
    });
    
    // Traditional button
    const traditionalButtons = document.querySelectorAll('a[href="#add-sample-traditional"]');
    traditionalButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Traditional sample button clicked');
        const variantId = findVariantByOptions('traditional');
        addToCart(variantId);
      });
    });
    
    // Keep backward compatibility with old button
    const genericButtons = document.querySelectorAll('a[href="#add-sample-to-cart"]');
    genericButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Generic sample button clicked');
        const variantId = findVariantByOptions('peel'); // Default to Peel & Stick
        addToCart(variantId);
      });
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSampleButtons);
  } else {
    initSampleButtons();
  }
})();
